import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";

import "./scss/common-table.scss";
import moUser from "@store/user";
import moIndex from '../store/index';

interface IProps {
  leftList: Array<any>;
  rightList: Array<any>;
}
interface IState {}

const CommonTable = (props: IProps, state: IState) => {
  const { leftList, rightList } = props;
  const { isLogin } = moUser;
  const { isMock } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section
      className={["in-common-table-warp", !isMock ? "" : "mock-100"].join(" ")}
    >
      <section
        className="left"
        style={{
          width: `${
            (100 / (leftList?.length + rightList[0]?.length)) * leftList?.length
          }%`,
        }}
      >
        {leftList?.map((res: any, r: any) => {
          return (
            <section
              key={r}
              className="item"
              style={{ width: `${100 / leftList?.length}%` }}
            >
              {res?.map((ele: any, e: any) => {
                return <p key={e}>{ele}</p>;
              })}
            </section>
          );
        })}
      </section>
      <section className="right-warp">
        {rightList?.map((res: any, r: any) => {
          return (
            <section key={r} className="item">
              {res?.map((ele: any, e: any) => {
                return (
                  <p
                    key={e}
                    style={{
                      width:
                        rightList[0].length + leftList.length <= 8
                          ? `${100 / rightList[0].length}%`
                          : "12.5%",
                    }}
                  >
                    {ele.toLocaleString()}
                  </p>
                );
              })}
            </section>
          );
        })}
      </section>
    </section>
  );
};

export default observer(CommonTable);
